import { render, staticRenderFns } from "./BankComponent.vue?vue&type=template&id=fc2383d6"
import script from "./BankComponent.vue?vue&type=script&lang=js"
export * from "./BankComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports